import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import { useToastMutation } from '../utils/mutation';
import type { ProjectRole } from '../../types/project';

export interface ProjectAccount {
  id: string;
  email: string;
  role: string[];
  projectRole: ProjectRole;
  firstName: string;
  lastName: string;
  fullName: string;
  sortName: string;
  name: string;
  emailVerified: boolean;
  mfaEnabled: boolean;
  phone: string | null;
}

export function useProjectUsers(projectId: string) {
  return useQuery<ProjectAccount[]>({
    queryKey: ['projectUsers', projectId],
    queryFn: () => api.get<ProjectAccount[]>(`/account/project/${projectId}/false`),
    enabled: !!projectId,
  });
}

export function useUpdateUserRole(projectId: string) {
  return useToastMutation(
    ['projectUsers', projectId],
    ({ accountId, roleId }: { accountId: string; roleId: string; fullName: string; roleName: string }) =>
      api.put(`/account/${accountId}/project/${projectId}/role/${roleId}`),
    {
      success: (_d, v) => ({ title: 'Account Role Updated', description: `${v.fullName} is now ${v.roleName}`, timeout: 2500 }),
    }
  );
}

export function useRemoveUser(projectId: string, projectName?: string) {
  return useToastMutation(
    ['projectUsers', projectId],
    ({ accountId, role }: { accountId: string; role: ProjectRole; fullName: string }) =>
      api.delete(`/account/${accountId}/project/${projectId}`, { role }),
    {
      success: (_d, v) => ({ title: 'Account Removed', description: `${v.fullName} removed from ${projectName ?? ''}`, timeout: 2500 }),
    }
  );
}
